// src/store/tierPickerManagment/actions.ts

import { Dispatch } from 'redux';

import {
  OPEN_TIER_PICKER,
  CLOSE_TIER_PICKER,
  TierPickerActionTypes,
  PurchaseTier,
} from './types';

export const openTierPicker = (
  label: string,
  tiers: PurchaseTier[],
) => (dispatch: Dispatch<TierPickerActionTypes>) => {
  dispatch({
    type: OPEN_TIER_PICKER,
    payload: { label, tiers },
  });
};

export const closeTierPicker = () => (dispatch: Dispatch<TierPickerActionTypes>) => {
  dispatch({ type: CLOSE_TIER_PICKER });
};
